// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8a87e17e","513":"234a2ad2","703":"68cdd557","787":"8e0173e6"}[chunkId] + ".chunk.js";
};